var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"p-grid bgColorClass"},[_c('div',{staticClass:"p-lg-offset-2 p-lg-8 p-md-offset-2 p-md-8 p-offset-1 p-col-11"},[_c('p',[_vm._v(_vm._s(_vm.test))]),_vm._v(" "),_c('div',{attrs:{"id":"token"}}),_c('div',{attrs:{"id":"msg"}}),_c('div',{attrs:{"id":"notis"}}),_c('div',{attrs:{"id":"err"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }